import { SpriteIcon } from '@/components/SpriteIcon';

/**
 * The primary action on every auth form.
 *
 * Each Razor page hand-rewrote the button's innerHTML in its own `@section
 * Scripts` to show a spinner on submit, which is why the disabled state and the
 * trailing "..." differ slightly from page to page. One implementation here, and
 * the pending state comes from the mutation rather than from a submit listener
 * that has no idea whether the request finished.
 */
export function SubmitButton({
  icon,
  label,
  pending,
  variant = 'primary',
  pendingLabel,
}: {
  icon: string;
  label: string;
  pending: boolean;
  /** `success` on the activation screen; `primary` everywhere else. */
  variant?: string;
  /** Defaults to the label with "..." appended, as the inline scripts did. */
  pendingLabel?: string;
}) {
  return (
    <button
      type="submit"
      className={`btn btn-${variant} btn-lg d-flex align-items-center justify-content-center`}
      disabled={pending}
    >
      {pending ? (
        <span className="spinner-border spinner-border-sm me-2" aria-hidden="true" />
      ) : (
        <SpriteIcon name={icon} className="sa-icon me-2" />
      )}
      {pending ? (pendingLabel ?? `${label}...`) : label}
    </button>
  );
}
